import { CollectionFunction, CollectionFunctionFormData } from 'data/collectionFunction/collectionFunction.types';
import { Operation, WithAuditDetails } from 'data/types';
import { adaptToSubmit, setCollectionFunctionOperationValues } from 'data/collectionFunction/collectionFunction.adapter';

export default function getCollectionFunctionDataToSubmit(
  collectionFunctionFormData: CollectionFunctionFormData,
  originalCollectionFunction: CollectionFunction | null,
  operation: Operation,
): WithAuditDetails<CollectionFunction> {
  const adaptedFormData = adaptToSubmit(collectionFunctionFormData);
  const dataToSubmit = setCollectionFunctionOperationValues(adaptedFormData, originalCollectionFunction, operation);

  const collectionFunctionBody: WithAuditDetails<CollectionFunction> = {
    data: dataToSubmit,
  };

  if (operation === 'UPDATE') {
    collectionFunctionBody.originalData = originalCollectionFunction || null;
  }

  return collectionFunctionBody;
}
